import { DataServer } from "../../../config.axios";
import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";

interface TpiElementWiseDamagesState {
  ElementWiseDamages: {
    load: boolean;
    data: [];
  };
}

export const ElementWiseDamagesSlice = createSlice({
  name: "ElementWiseDamages",
  initialState: {
    ElementWiseDamages: {
      load: false,
      data: [],
    },
  } as TpiElementWiseDamagesState,
  reducers: {},
  extraReducers: (builder: any) => {
    builder
      .addCase(fetchElementWiseDamages.pending, (state: TpiElementWiseDamagesState) => {
        state.ElementWiseDamages.load = true;
      })
      .addCase(fetchElementWiseDamages.fulfilled, (state: TpiElementWiseDamagesState, action: any) => {
        state.ElementWiseDamages.data = action.payload;
        state.ElementWiseDamages.load = false;
      })
      .addCase(fetchElementWiseDamages.rejected, (state: TpiElementWiseDamagesState) => {
        state.ElementWiseDamages.load = false;
      });
  },
});

export default ElementWiseDamagesSlice.reducer;

export const fetchElementWiseDamages = createAsyncThunk(
  "ElementWiseDamages/fetchElementWiseDamages",
  async (param: {apiParam: {project_pin: any, layout_id: any}}, thunkAPI) => {
    try {
      const { data } = await DataServer.post("api/getLayoutWiseTpiTotalElementsCount", {
        project_pin: param.apiParam.project_pin,
        layout_id: param.apiParam.layout_id
      });
      return data.data;
    } catch (error) {
    }
  }
);
